@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/style-helpers.scss';

:host {
  border-bottom: 1px solid var(--chart-101-pressed-dividers);
}

:host([disabled]) {
  pointer-events: none;
  opacity: 0.6;
}

.wrapper {
  justify-content: space-between;
  padding: var(--spacer) calc(var(--spacer) * 2.5) calc(var(--spacer) / 2);
  align-items: center;

  .filters-container {
    flex: 1;
    display: flex;
    flex-wrap: wrap;

    .filter {
      margin-right: calc(2 * var(--spacer));
      margin-bottom: calc(var(--spacer) * 1.25);
      margin-top: calc(var(--spacer));
    }
  }

  .filters-action-buttons {
    min-height: 52px;
    display: flex;
    align-items: center;
    align-self: flex-start;
    padding: 0 0 var(--spacer) var(--spacer);
  }
  .dropdown-filter {
    width: auto;
  }

  gz-tags-network-filter {
    width: auto;
  }
}

:host([displayMode='pdf']) {
  border: none;
  padding-left: 5px;

  .wrapper {
    display: none;
  }
}
